module.exports = __webpack_public_path__ + "img/SketchPng9deba24031865af229edbda0e26373d078dc6639b185f16fca0874227a4f6d88.4ec93ec5.png";